import { _default } from "@max/index"
import Money from "./Money"
import { cache, storage } from "@platform/index"
import { globalInfo } from "../env/util"

let money: Money
export const _money = {
  init({ moneyConfig, defaultCurrency }) {
    if (!moneyConfig)
      throw new Error(
        `Money init fail: ${defaultCurrency} ${JSON.stringify(moneyConfig)}`
      )
    let _currency = defaultCurrency
    if (globalInfo.get('appId')
      && __platform) {
      const currencyId = `__currency__${globalInfo.get('appId')}`
      const cacheCur = cache.get(currencyId) || storage.get(currencyId)
      cacheCur && (_currency = cacheCur as TCurrency)
    }
    money = new Money(moneyConfig, _currency)
  },
  of(value, currency, hmp) {
    return money?.of(value, currency, hmp)
  },
  ofMajor(value, currency, hmp) {
    return money?.ofMajor(value, currency, hmp)
  },
  isMoney(value, hmp) {
    return money?.isMoney(value, hmp)
  },
  equals(money1, money2) {
    return money?.equals(money1, money2)
  },
  compare(money1, money2) {
    return money?.compare(money1, money2)
  },
  getContext(currency) {
    let _currency = currency
    if (!_currency
      && globalInfo.get('appId')
      && __platform) {
      const currencyId = `__currency__${globalInfo.get('appId')}`
      const cacheCur = cache.get(currencyId) || storage.get(currencyId)
      cacheCur && (_currency = cacheCur as TCurrency)
    }
    return money?.getContext(_currency)
  },
  setContext(currency) {
    const flag = money?.setContext(currency)
    if (flag
      && globalInfo.get('appId')
      && __platform) {
      const currencyId = `__currency__${globalInfo.get('appId')}`
      cache && cache.set(currencyId, currency)
      storage && storage.set(currencyId, currency)
    }
    return flag
  },
  format(value, pattern) {
    return money?.format(value, pattern)
  },
  // parse(str, pattern, currency) {
  //   return money?.parse(str, pattern, currency)
  // },
  toMajor(val) {
    return money?.toMajor(val)
  },
  symbol(val) {
    return money?.symbol(val)
  },
  currency(val) {
    return money?.currency(val)
  },
  locale(val) {
    return money?.locale(val)
  },
  subtract(a, b, hmp) {
    return money?.subtract(a, b, hmp)
  },
  multiply(a, b, mode, hmp) {
    return money?.multiply(a, b, mode, hmp)
  },
  divide(a, b, mode, hmp) {
    return money?.divide(a, b, mode, hmp)
  },
  add(a, b, hmp) {
    return money?.sum(a, b, hmp)
  },
  avg(...args) {
    return money?.avg(...args)
  },
  around(moneyObj, mode = 'auto', offset = 0, interval = 'unit', strategy?: string) {
    return money?.around(moneyObj, mode, offset, interval, strategy)
  },
  // distribution(a, b) {
  //   return money?.distribution(a, b)
  // },
  // amount(value) {
  //   return money?.amount(value)
  // },
  // payAmount(value) {
  //   return money?.payAmount(value)
  // },
  // floor(amount, base) {
  //   return money?.floor(amount, base)
  // },
  // ceil(amount, base) {
  //   return money?.ceil(amount, base)
  // },
  min(money1, money2) {
    return money?.min(money1, money2)
  },
  max(money1, money2) {
    return money?.max(money1, money2)
  },
  formatParts(value, pattern) {
    return money?.formatParts(value, pattern)
  },
} as MoneyDSL
